<template>
    <Modal>
        <div class="modal-container" slot="modal-container">
            <h2>{{$t('modal.finish-profile.headline')}}</h2>
            <p class="text">{{$t('modal.finish-profile.text')}}</p>
            <form>
                <div class="material-input">
                    <input
                        type="text"
                        v-model="name"
                        v-on:keyup="onKeyUpName"
                        v-bind:class="{active: isActiveName}"
                    />
                    <label>{{ $t('modal.placeholder.input-name') }}</label>
                </div>
                <div class="radio-group">
                    <p class="subject">{{$t('modal.finish-profile.company-label')}}</p>
                    <label for="no" class="custom-radio">
                        <p>{{ $t('no') }}</p>
                        <input name="" id="no" type="radio" value="0" v-model="isCompany">
                        <span class="radio-circle"></span>
                    </label>
                    <label for="yes" class="custom-radio">
                        <p>{{ $t('yes') }}</p>
                        <input name="" id="yes" type="radio" value="1" v-model="isCompany">
                        <span class="radio-circle"></span>
                    </label>
                </div>
                <div class="material-input" v-if="isCompany == 1">
                    <input
                        type="text"
                        v-model="vat_no"
                        v-on:keyup="onKeyUpVatno"
                        maxlength="8"
                        v-bind:class="{ active: isActiveVatno }"
                        v-on:keypress="isNumber(event)"
                    />
                    <label>{{ $t('modal.placeholder.input-vatno') }}</label>
                </div>
            </form>
            <button class="purple" v-on:click="submit" :disabled="saving || (isCompany == 1 && vat_no.length != 8) || (name.length < 2 )">
                {{ $t('modal.finish-profile.button') }}
            </button>
        </div>
    </Modal>
</template>

<script>
    import Vue from 'vue';
    import Modal from './Modal.vue';

    export default {
        data: () => ({
            name: '',
            vat_no: '',
            saving: false,
            isActiveName: false,
            isActiveCompany: false,
            isActiveVatno: false,
            isCompanyActive: false,
            isCompany: 0
        }),
        components: {
            Modal,
        },
        methods: {
            onKeyUpName: function(){
                this.isActiveName = true;
            },
            onKeyUpCompany: function(){
                this.isActiveCompany = true;
            },
            onKeyUpVatno: function(){
                this.isActiveVatno = true;

                if (this.vat_no.length == 8) {
                    Vue.$company.lookup(this.vat_no);
                }
            },
            isNumber: function(evt) {
              evt = (evt) ? evt : window.event;
              var charCode = (evt.which) ? evt.which : evt.keyCode;
              if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
              } else {
                return true;
              }
            },
            submit() {
                Vue.api.post('/user/finish-profile', {
                    full_name: this.name,
                    vat_no: this.vat_no,
                }, {
                    before: () => this.saving = true,
                    always: () => this.saving = false,
                    callback: () => {
                        this.$store.dispatch('fetchUserData');
                        this.$store.commit('setSuccessBarMessage', this.$t('dashboard.finish-profile.completed.label'));
                        this.$emit('done');
                    },
                });
            },
        },
    }
</script>
